import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { UtilidadesService } from '../servicios/utilidades.service';

@Injectable({
  providedIn: 'root'
})
export class VerificarPrivilegiosGuard implements CanActivate {
  constructor(private utilidades: UtilidadesService, private route: Router, private nav: NavController) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    setTimeout(() => {
      let path = this.route.url.replace("/", "")

      if (path.indexOf("/") > -1) {
        path = path.substring(0, path.indexOf("/"))
      }
      if (this.utilidades.VerificarPrivilegio(path)) {
        return true
      } else {
        this.nav.navigateForward("/home")
        return false
      }
    }, 50);

    return true
  }

}
